"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactSpring = require("react-spring");

var _context = require("../context");

var _utils = require("../utils");

var _Portal = _interopRequireDefault(require("./Portal"));

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var fixedProps = {
  position: 'fixed',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};
var ZIndexWrapper = (0, _context.styledWithTheme)('div')(function (_ref) {
  var theme = _ref.theme,
      zIndex = _ref.zIndex,
      shouldEnablePointerEvents = _ref.shouldEnablePointerEvents;
  return _objectSpread({
    zIndex: theme.selectors.zIndex(zIndex),
    pointerEvents: shouldEnablePointerEvents ? 'initial' : 'none'
  }, fixedProps);
});

var Backdrop = /*#__PURE__*/_react.default.forwardRef(function (_ref2, backdropRef) {
  var children = _ref2.children,
      opacity = _ref2.opacity,
      zIndex = _ref2.zIndex,
      _ref2$shouldEnablePoi = _ref2.shouldEnablePointerEvents,
      shouldEnablePointerEvents = _ref2$shouldEnablePoi === void 0 ? true : _ref2$shouldEnablePoi,
      dataTestComponent = _ref2.dataTestComponent;
  var bodyOverflow = (0, _react.useRef)('');
  var bodyRightMargin = (0, _react.useRef)(0);
  var zIndexRef = (0, _react.useRef)(null);
  var ref = backdropRef || zIndexRef;

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      selectors = _useContext.selectors,
      isRTL = _useContext.isRTL;

  var NEUTRAL90 = selectors.color('neutral90'); // Prevent content behind the backdrop from scrolling

  (0, _react.useEffect)(function () {
    // If backdrop is already rendered by another component,
    // leave the document.body logic first rendered component.
    if (document.body.dataset.backdrop === 'true') {
      return;
    }

    bodyOverflow.current = document.body.style.overflow || '';
    bodyRightMargin.current = parseInt(document.body.style.marginRight || '0');
    document.body.dataset.backdrop = 'true';

    if (window.innerWidth > document.body.scrollWidth) {
      document.body.style.marginRight = (0, _utils.px)(bodyRightMargin.current + window.innerWidth - document.body.scrollWidth);
    }

    document.body.style.overflow = 'hidden';
    var wrapperEl = ref.current && ref.current.parentElement;
    var parentElement = wrapperEl && wrapperEl.parentElement;

    var changeAriaHidden = function changeAriaHidden(state) {
      if (!!parentElement) {
        Array.from(parentElement.children).forEach(function (el) {
          if (el.tagName !== 'SCRIPT' && el !== wrapperEl) {
            if (state && !el.attributes['aria-hidden']) {
              el.setAttribute('aria-hidden', 'true');
              el.setAttribute('aria-hidden-added', 'true');
            } else if (!state && el.hasAttribute('aria-hidden-added')) {
              el.removeAttribute('aria-hidden');
              el.removeAttribute('aria-hidden-added');
            }
          }
        });
      }
    };

    changeAriaHidden(true); // Reset the overflow on unmount

    return function () {
      delete document.body.dataset.backdrop;
      document.body.style.overflow = bodyOverflow.current;
      document.body.style.marginRight = bodyRightMargin.current !== 0 ? (0, _utils.px)(bodyRightMargin.current) : null;
      changeAriaHidden(false);
    };
  }, [ref]);
  return (0, _core.jsx)(_Portal.default, null, (0, _core.jsx)(ZIndexWrapper, {
    zIndex: zIndex,
    ref: ref,
    dir: isRTL ? 'rtl' : undefined,
    shouldEnablePointerEvents: shouldEnablePointerEvents
  }, (0, _core.jsx)(_reactSpring.animated.div, {
    "data-test-component": dataTestComponent,
    style: _objectSpread(_objectSpread({}, fixedProps), {}, {
      backgroundColor: NEUTRAL90,
      opacity: opacity
    })
  }), children));
});

Backdrop.displayName = 'Backdrop';
var _default = Backdrop;
exports.default = _default;